import React from 'react';
import { useTranslation } from 'react-i18next';
import { Brain, Leaf, Globe, Award } from 'lucide-react';

const WhyChooseUs = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: Brain,
      titleKey: 'whyChooseUs.expertise',
      descKey: 'whyChooseUs.expertiseDesc',
      iconType: 'ai',
    },
    {
      icon: Leaf,
      titleKey: 'whyChooseUs.aiIntegration',
      descKey: 'whyChooseUs.aiIntegrationDesc',
      iconType: 'ayurveda',
    },
    {
      icon: Globe,
      titleKey: 'whyChooseUs.globalReach',
      descKey: 'whyChooseUs.globalReachDesc',
      iconType: 'ai',
    },
    {
      icon: Award,
      titleKey: 'whyChooseUs.certified',
      descKey: 'whyChooseUs.certifiedDesc',
      iconType: 'ayurveda',
    },
  ];

  return (
    <section
      id="why-choose-us"
      style={{
        background: '#0A1628',
        padding: '5rem 1.2rem',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '50%',
          height: '100%',
          backgroundImage: 'url(https://images.unsplash.com/photo-1512290923902-8a9f81dc236c?q=80)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.25,
          zIndex: 0,
        }}
      />
      
      <div
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: '50%',
          height: '100%',
          background: 'radial-gradient(circle at 80% 50%, rgba(34, 197, 94, 0.15) 0%, transparent 50%)',
          zIndex: 0,
        }}
      />
      
      <div className="data-grid-bg" />

      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        <div style={{ textAlign: 'center', marginBottom: '3rem', maxWidth: '800px', margin: '0 auto 3rem' }}>
          <h2 className="heading-1" style={{ marginBottom: '1rem', color: 'var(--text-light)' }}>
            {t('whyChooseUs.title')}
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            {t('whyChooseUs.subtitle')}
          </p>
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '2rem',
          }}
        >
          {features.map((feature, index) => {
            const IconComponent = feature.icon;
            return (
              <div
                key={index}
                style={{
                  background: 'rgba(255, 255, 255, 0.05)',
                  backdropFilter: 'blur(12px)',
                  WebkitBackdropFilter: 'blur(12px)',
                  borderRadius: '1rem',
                  padding: '2rem',
                  border: '1px solid rgba(34, 197, 94, 0.3)',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 20px rgba(34, 197, 94, 0.1)',
                }}
                className="hover-lift"
              >
                <div
                  className={`icon-container-${feature.iconType}`}
                  style={{
                    width: '3.5rem',
                    height: '3.5rem',
                    borderRadius: '1rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '1.25rem',
                  }}
                >
                  <IconComponent size={28} color="white" />
                </div>
                <h3 className="heading-3" style={{ marginBottom: '0.75rem', color: 'var(--tech-green-300)' }}>
                  {t(feature.titleKey)}
                </h3>
                <p className="body-small" style={{ color: 'var(--text-secondary)' }}>
                  {t(feature.descKey)}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
